import { FormPropertyType, GlazedSurface, ProjectPropertyType } from '@/helper/Types'
import { AbstractCalculatedLoad } from '@/services/models/AbstractCalculatedLoad'

export class CalculatedCoolingLoadRequest extends AbstractCalculatedLoad {

  public coolingBuildingInfo: {
    indoorTemperature: number | undefined
    glazedSurfaces: GlazedSurface[] | undefined
    ventilationType: string | undefined
  } = {
    indoorTemperature: undefined,
    glazedSurfaces: undefined,
    ventilationType: undefined
  }

  constructor(props: ProjectPropertyType, formData: Partial<FormPropertyType>) {
    super(props, formData)

    this.coolingBuildingInfo.indoorTemperature = this.getPropsRevertValue(props, formData, 'coolingIndoorTemperature') as number | undefined
    this.coolingBuildingInfo.glazedSurfaces = this.getPropsRevertValue(props, formData, 'glazedSurfaces') as | GlazedSurface[] | undefined
    this.coolingBuildingInfo.ventilationType = this.getPropsRevertValue(props, formData, 'coolingVentilationType') as | string | undefined
  }

  public validate(): boolean {
    if (!super.validate()) {
      return false
    }

    this.coolingBuildingInfo.glazedSurfaces = this.coolingBuildingInfo.glazedSurfaces?.filter(gs => {
      return (gs.orientation || '') && gs.height && gs.width
    })

    return !!(
      this.coolingBuildingInfo.indoorTemperature
      && this.coolingBuildingInfo.glazedSurfaces?.length
      && this.coolingBuildingInfo.ventilationType
    )
  }
}
